<template>
  <div id="app" :class="`${this.isLoggedIn ? 'logged_in' : 'not_logged'}`">
    <div class="wrapper">
      <SidebarMenu @collapse="toggleSidebarCollapsed" ref="sidebarMenuComponent"></SidebarMenu>

      <div id="content">
        <b-navbar toggleable="md" type="dark" sticky variant="dark" class="really-dark">
          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

          <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav>
              <b-nav-item class="d-none d-sm-block" href="#" @click.prevent.stop>
                <div class="toggleSidebar" @click="toggleSidebar" id>
                  <i v-if="sidebarIsCollapsed" class="fas fa-chevron-right"></i>
                  <i v-else class="fas fa-chevron-left"></i>
                </div>
              </b-nav-item>

              <div class="d-block d-sm-none">
                <b-nav-item to="/teams">
                  <i class="fas fa-users"></i>
                  Times
                </b-nav-item>
                <b-nav-item to="/tournaments">
                  <i class="fas fa-trophy"></i>
                  Campeonatos
                </b-nav-item>
                <b-nav-item to="/clubs">
                  <i class="fas fa-place-of-worship"></i>
                  Clubs
                </b-nav-item>
                <b-nav-item to="/practice" v-if="isLoggedIn">
                  <i class="fas fa-chess"></i>
                  <!-- <i class="fas fa-people-carry"></i> -->
                  <!-- <i class="fas fa-charging-station"></i> -->
                  Treinos
                </b-nav-item>
                <b-nav-item to="/suporte">
                  <i class="far fa-question-circle"></i>
                  Suporte
                </b-nav-item>
                <b-nav-item to="/loadout">
                  <div class="w-icon-menu">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" xml:space="preserve" viewBox="0.77 0 83 40"><path d="M72.75 17.6a28.7 28.7 0 0 0-8.09-6.41c-2.32-1.28-4.77-2.45-7.4-2.96-1.68-.33-3.37-.77-5.08-.9l-3.62-.29-1.1-.08c-.05 0-.27-.63-.39-.78-.4-.5-1.96.02-2.57.1-.29.03-.7.58-.9.76-.59.52-1.33.86-2.05 1.14-1.96.76-4.34.95-6.44.77-.35-.04-.8-.13-1.15-.1-.18.02-.38.18-.55.16-.2-.01-.49-.22-.66-.3-.37-.17-.47-.27-.84-.18l-1.77.43a42 42 0 0 0-10.22 3.77c-.77.4-1.52.83-2.28 1.25-.13.07-.12.1-.16.26-.04.14-.25.19-.37.25-.3.15-.61.28-.8.56-.17.26-.31.46-.63.53-.6.14-.98.06-1.1.78-.09.52-.2.3-.52.3-.4-.01-1.07.07-1 .62-.13.36-.13.57-.5.67-.25.06-.5-.27-.77-.27-.3 0-.5.22-.6.48-.17.43-.1.77-.6.82-.31.03-1-.33-.9.32.1.88-1.27.5-1.57.94-.3.42-.44.9-.58 1.38-.12.44.03.47.34.81-.3.15-.78.27-.88.6l-.36 1.27-.79 2.75a9.25 9.25 0 0 1-1.1 2.4c-.18.3-.72.87-.75 1.21-.06.7 1.97.8 2.43.91.3.07.5.3.75.45l1.31.78c1.56.94 3.39 1.55 5.2 1.09a7.03 7.03 0 0 0 5.2-7.1c.32.25.5-.44.6-.62.36-.62.7-1.23 1.2-1.73 1.15-1.15 2.72-1 4.2-.88.42.03.47-.32.7-.64.45-.68.94-1.32 1.59-1.84a5.7 5.7 0 0 1 5.3-1c.64.2.64.32.94-.3a6.12 6.12 0 0 1 1.98-2.18 4.56 4.56 0 0 1 5.23.07c.83.6 1.53 1.47 2 2.38.2.37.44 1.62.94 1.7.39.07 2.06-.61 2.3-.9.35-.43-.2-.62.37-.85a38.75 38.75 0 0 1 5.32-1.45c2.61-.47 5.27-.6 7.92-.36 3.42.3 7 1.54 10.04 3.1 3.7 1.9 7.23 4.85 9.48 8.38-.24-2.07-1.18-4.14-2.13-5.98a32.29 32.29 0 0 0-4.12-6.1m-61.39 5.35c.81-.02 1.61-.11 2.4.16a5.29 5.29 0 0 1 3.09 3.5c.4 1.57.04 3.3-1.06 4.5a4.15 4.15 0 0 1-2.94 1.4c-1.11.1-1.83.03-2.85-.58a4.58 4.58 0 0 1-2.05-2.67 5.52 5.52 0 0 1 .13-3.54c.37-1.19 2-2.67 3.28-2.77"/><path fill="none" d="M83 0h84v40H83zM0 0h83v40H0z"/></svg>
                  </div>
                  Skins
                </b-nav-item>

                <b-nav-item
                  v-if="isLoggedIn && currentUser && !currentUser.is_premium"
                  to="/premium"
                >Seja Premium</b-nav-item>
              </div>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-item
                v-if="isLoggedIn && currentLobby.id == ''"
                class="play-now-nav"
                @click="openPlayModal"
              >JOGAR AGORA</b-nav-item>
              <b-nav-item to="/notifications" v-if="isLoggedIn">
                <small class="notifications-count">{{notificationsCount}}</small>
                Inbox
              </b-nav-item>

              <b-nav-item-dropdown right v-if="isLoggedIn">
                <template slot="button-content">
                  <em v-if="currentUser && currentUser.nickname">@{{currentUser.nickname}}</em>
                </template>
                <b-dropdown-item
                  :to="{ name: 'UserSingle', params: { id: currentUser.slug }}"
                  v-if="currentUser && currentUser.slug"
                >Meu Perfil</b-dropdown-item>
                <!-- <b-dropdown-item to="/account/dashboard">Créditos/Premium</b-dropdown-item> -->
                <b-dropdown-item
                  v-on:click.prevent="showChangePassword = !showChangePassword"
                >Alterar senha</b-dropdown-item>
                <b-dropdown-item v-on:click.prevent="logout">Sair</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item v-else :to="{ name: 'Login' }">Faça Login</b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        <notifications group="all"/>

        <div class="container-fluidddd">
          <router-view @openModal="openModalFromComponent"/>
        </div>
        <footer class="locomotiva text-muted" v-if="true">
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-2">
                <p class="footer-logo">
                  <b-img src="/img/queota-branco-sem-fundo.png"/>

                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a href="https://twitter.com/QUEOTAclub" target="_blank">
                        <i class="fab fa-twitter-square"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="https://www.facebook.com/queotaclub" target="_blank">
                        <i class="fab fa-facebook-square"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="https://instagram.com/QUEOTA.club" target="_blank">
                        <i class="fab fa-instagram"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="https://discord.gg/682TmqAd5U" target="_blank">
                        <i class="fab fa-discord"></i>
                      </a>
                    </li>
                  </ul>
                </p>
              </div>

              <div class="col-12 col-md-8">

                <div class="row">

                  <div class="col-12 col-md-4">
                    <h5>QUEOTA.club</h5>
                    <ul class="list-unstyled">
                      <li class="list-item">
                        <a href="mailto:queota@queota.club">Entre em contato</a>
                      </li>
                      <li class="list-item">
                        <router-link to="/blogposts">Blog</router-link>
                      </li>
                      <li class="list-item">
                        <router-link to="/forum">Fórum</router-link>
                      </li>
                      <li class="list-item">
                        <a href="https://discord.gg/682TmqAd5U" target="_blank">Discord</a>
                      </li>
                      <li class="list-item">
                        <router-link to="/suporte">Ajuda / FAQ</router-link>
                      </li>
                      <li class="list-item">
                        <a href="https://fightback.club" target="_blank">FIGHTBACK.club</a>
                      </li>
                    </ul>
                  </div>

                  <div class="col-12 col-md-4">
                    <h5>Comunidade</h5>
                    <ul class="list-unstyled">
                      <li class="list-item">
                        <router-link to="/teams">Times</router-link>
                      </li>
                      <li class="list-item">
                        <router-link to="/tournaments">Campeonatos</router-link>
                      </li>
                      <li class="list-item">
                        <router-link to="/clubs">Clubs</router-link>
                      </li>
                      <!-- <li class="list-item">
                        <router-link to="/wall_of_shame">Usuários Banidos</router-link>
                      </li> -->
                      <li class="list-item">
                        <router-link to="/lobbies">Últimas partidas</router-link>
                      </li>
                      <li class="list-item">
                        <router-link to="/ranked_stats">Ranking geral</router-link>
                      </li>
                    </ul>
                  </div>

                  <div class="col-12 col-md-4">
                    <h5>Para empresas</h5>
                    <ul class="list-unstyled">
                      <li class="list-item">
                        <router-link to="/tournaments/new">Crie seu campeonato</router-link>
                      </li>
                      <li class="list-item">
                        <router-link to="/clubs">Grupos fechados</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>


              <div class="col-12 col-md-2">
                <p v-if="true">
                  <small>by</small>
                  <a class="loco-logo" href="https://locomotiva.info">
                    <b-img src="/img/logo-loco.png"/>
                  </a>
                </p>

                <p>Criamos ferramentas para profissionalizar o cenário de CS:GO.</p>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-12 text-center">
                <p>&copy; 2017-2019 QUEOTA.club Todos os direitos reservados</p>
              </div>
            </div>
          </div>
        </footer>

        <ForumWidget v-if="isLoggedIn"></ForumWidget>

        <Matchmaking ref="matchmakingWidget" v-if="isLoggedIn"></Matchmaking>

        <Onboarding v-if="isLoggedIn && currentUser && !currentUser.onboarding_done"></Onboarding>
        <PasswordOnboarding :showClose="true" v-if="showPasswordOnboarding"></PasswordOnboarding>
        <SteamIdOnboarding :showClose="true" v-if="isLoggedIn && currentUser && (currentUser.steamid == '' || currentUser.steamid == null)"></SteamIdOnboarding>

        <LobbyWidget
          ref="lobbyWidget"
          v-if="isLoggedIn && currentLobby && currentLobby.id && currentLobby.pug_server"
        ></LobbyWidget>

        <b-modal
          id="playNowModal"
          ref="playNowModal"
          header-bg-variant="dark"
          header-text-variant="light"
          :hide-footer="true"
          :hide-header="true"
          size="md"
          body-class="modal-playnow"
        >
          <b-container fluid>
            <div class="row justify-content-between">
              <div class="col-12">
                <div class="playnow-menu">
                  <h5 class="section-title">escolha o modo de jogo</h5>
                  <!-- @click.stop.prevent="hideModal('/forfun')" -->
                  <a
                    href="/forfun"
                    class="btn btn-block section-link"
                    @click.stop.prevent="() => {}"
                    style="opacity: 0.5"
                    v-b-tooltip.hover
                    title="em breve"
                  >
                    <h2>Aquecimento</h2>
                    <p>DM para aquecer sua mira</p>
                  </a>

                  <a
                    href="/rooms"
                    @click.stop.prevent="hideModal('/rooms')" 
                    class="btn btn-block section-link"
                  >
                    <h2>Lobbies</h2>
                    <p>cria uma sala com seus amigos</p>
                  </a>

                  <!-- @click.stop.prevent="hideModal('/ranked')" -->
                  <a
                    href="/ranked"
                    @click.stop.prevent="() => {}"
                    class="btn btn-block section-link"
                    style="opacity: 0.5"
                    v-b-tooltip.hover
                    title="em breve"
                  >
                    <h2>Ranked</h2>
                    <p>busque uma partida e upe seu level</p>
                  </a>
                </div>
              </div>
            </div>
          </b-container>
          <!-- <PlayNow ref="playNow"></PlayNow>
        </b-modal>

        <b-modal
          id="anticheatModal"
          ref="anticheatModal"
          header-bg-variant="dark"
          header-text-variant="light"
          :hide-footer="true"
          :hide-header="true"
          size="md"
          body-class="modal-anticheat"
        >
          <b-container fluid>
            <h5 class="section-title">baixe o anticheat</h5>

            <p class="lead">para jogar você precisa estar com o nosso anticheat e o CS rodando.</p>

            <p class="lead">clique abaixo para fazer o download</p>

            <a href="/ac/QUEOTA.club.exe" class="btn btn-block ac-link">
              <img src="/img/icons/mstile-310x310.png" alt="QUEOTA.club">
              <h2>Anticheat QUEOTA.club</h2>
              <p>v 2.2.1.0</p>
            </a>

            <small>
              <a
                href="https://www.virustotal.com/gui/url-analysis/u-de6e390f502d14e6b44b4e25d222afb1bee3b572eb89befeef4de635e2836db0-1556843103/detection"
                target="_blank"
              >
                livre de vírus -
                <strong>confira</strong>
              </a>
            </small>
          </b-container> -->
        </b-modal>

        <Chat v-if="isLoggedIn"></Chat>
      </div>
    </div>
  </div>
</template>

<script>
import Chat from "@/components/Chat";
import Matchmaking from "@/components/Matchmaking";
import ForumWidget from "@/components/ForumWidget";
import Onboarding from "@/components/Onboarding";
import PasswordOnboarding from "@/components/PasswordOnboarding";
import SteamIdOnboarding from "@/components/SteamIdOnboarding";
import LobbyWidget from "@/components/LobbyWidget";
import PlayNow from "@/components/PlayNow";
import SidebarMenu from "@/components/SidebarMenu";

export default {
  name: "App",
  metaInfo: {
    title: "cs2 em grupos e amigos é aqui",
    titleTemplate: "%s | QUEOTA.club"
  },
  computed: {
  },
  data() {
    return {
      userChannelSubscription: {},
      showChangePassword: false,
      sidebarIsCollapsed: false
    };
  },
  methods: {
    toggleSidebar() {
      this.$refs.sidebarMenuComponent.toggleCollapse();
    },
    toggleSidebarCollapsed(val) {
      this.sidebarIsCollapsed = val;
    },
    logout() {
      this.$store.dispatch("logout");
    },
    openModalFromComponent(modalType) {
      if (modalType == "play") this.$refs.playNowModal.show();
      else this.$refs.anticheatModal.show();
    },
    openPlayModal() {
      if (!this.isAnticheatRunning) this.$refs.anticheatModal.show();
      else this.$refs.playNowModal.show();
    },
    hideModal(route) {
      this.$refs.playNowModal.hide();
      if (route == "/ranked") {
        if (
          this.$refs.matchmakingWidget.closed &&
          this.$refs.matchmakingWidget.state != "searching"
        )
          this.$refs.matchmakingWidget.togglePanel();
      } else {
        this.$router.push(route);
      }
    },
    initialize() {
      var self = this;
      if (this.isLoggedIn) {
        this.userChannelSubscription = this.$cable.subscriptions.create(
          { channel: "UserChannel" },
          {
            received: function(data) {
              self.$http.get("pages/my_account.json").then(response => {
                self.$store.dispatch("updateUserProfile", response.data);
              });
            }
          }
        );
      }
    }
  },
  mounted() {
    window.addEventListener(
      "beforeunload",
      function(event) {
        if (this.$cable) {
          this.$cable.disconnect();
        }
      },
      false
    );
    this.initialize();
  },
  components: {
    Matchmaking,
    ForumWidget,
    Onboarding,
    PasswordOnboarding,
    SteamIdOnboarding,
    LobbyWidget,
    Chat,
    PlayNow,
    SidebarMenu
  }
};
</script>


<style lang="sass" scoped>
  .small-logo
    width: 32px
    height: auto
  .really-dark
    background: #000 !important

  .wrapper
    display: flex
    align-items: stretch

    #content
      width: 100%
      min-height: 100vh
      transition: all 0.3s
      // position: relative
      // background: #e1e1e1
      // background: #111 url(https://queota.club/img/bg-queota-111.jpg) no-repeat top
      .topNavbar
        background: #111 !important
      // .container-fluid
      //   padding: 40px
      //   padding-top: 5px
      //   padding-bottom: 15px
        // background: white
      .toggleSidebar
        color: rgba(255, 255, 255, .3)
        cursor: pointer
        display: flex
        justify-content: center
        align-items: center
        padding: 0 6px 0 0
        margin-right: 10px
</style>

<style lang="sass">
@import url('https://fonts.googleapis.com/css?family=Rajdhani:700,500')
@import url('https://fonts.googleapis.com/css?family=Oswald:600')
@import url('https://use.fontawesome.com/releases/v5.6.3/css/all.css')

// @import url('https://rsms.me/inter/inter-ui.css')
// html { font-family: 'Inter UI', sans-serif; }
// @supports (font-variation-settings: normal)
//   html
//     font-family: 'Inter UI var alt', sans-serif'

$green: #62c462
// $blue: #008EB4
$red: #770000

$blue: #1985A1
$bluer: #2B59C3
// $blue: $bluer
$purple: #522D82

$font: 'Rajdhani'

.number-font
  font-family: 'Oswald', sans-serif

// 014EA5
a
  color: $blue
.fa.ready
  color: green
nav.navbar a.nav-link small.notifications-count
  display: inline-block
  background: rgba(255, 255, 255, .2)
  padding: 0px 3px
  border-radius: 4px
  font-size: 11px
  line-height: 14px
  position: relative
  top: -5px

@keyframes Gradient
  0%
    background-position-y: 0px
    opacity: .4
  50%
    background-position-y: -20px
    opacity: 1
  100%
    background-position-y: 0px
    opacity: .4

.play-now-nav
  background: rgb(164,4,4)
  background: linear-gradient(25deg, rgba(164,4,4,.6) 35%, rgba(51,5,5,0.7) 66%)
  background-size: 200% 200%
  animation: Gradient 3s ease infinite
  transition: all 1s
  border-radius: 4px

  &:hover
    animation: none
    transition: all .1s
    background: green

  a
    color: white

#nprogress .bar
  background: white
#nprogress .spinner-icon
  border-top-color: white
  border-left-color: white
body
  // background: #111 url(http://localhost:5000/assets/topheader-95fe60b8542f390d304dbef0035d9505e3aa65e4372a0aa0831e3787635a655b.jpg) no-repeat fixed center top
  // background: #d6d6d6 url(/img/page-background.jpg) no-repeat center top
  // background: #140432
  // background: rgb(20,4,50)
  // background: linear-gradient(180deg, rgba(20,4,50,1) 0%, rgba(34,11,74,1) 78%, rgba(31,9,71,1) 100%)
  // background: #111
  background: #111 url(/img/bg-queota-111.jpg) no-repeat center top

  color: #999
  -webkit-transition: -webkit-transform 0.5s
  transition: transform 0.5s
  -webkit-font-smoothing: antialiased
  // font-family: $font
h1,h2,h3,h4,h5,h6,.navbar,.dropdown-item,.btn,thead,p.heading
  font-family: $font
  font-weight: 700

.w-icon-menu
  width: 40px
  display: flex
  align-items: center
  justify-content: center
  margin: 0 auto
  margin-bottom: 10px

.forum-nav-link
  position: relative
  .forum-badge
    position: absolute
    top: 7px
    right: 1px
    width: 9px
    height: 9px
    border-radius: 200%
    padding: 0


.stats-table
  table.is-hoverable
    border-radius: 5px
    background: rgba(#3A3F44, .2)
    &.team1
      background: rgba($blue, .05)
    &.team2
      background: rgba($green, .05)
    abbr
      cursor: help
    tr
      transition: all .15s
      &.has-won
        background: rgba($green, .15)
      &.has-lose
        background: rgba($red, .05)
    td, th
      padding: 0.7em 0.75em
  table.table-sm
    td, th
      padding: 0.3em 0.45em
      font-size: 12px
  // a
  //   color: #008EB4

.no-results
  width: 100%
  padding: 20px
  text-align: center
  margin-bottom: 20px
  h1
    max-width: 350px
    color: #999

h2.title-lined
  text-transform: uppercase
  font-size: 16px
  font-weight: bold
  color: #999
  position: relative

  .title-line
    // background: #d6d6d6
    // padding: 0 10px 0 0
    position: relative
    display: inline
    z-index: 1


#playNowModal
  background: rgba(black, .8)
  .modal-content
    background: transparent
    border: 0

    .playnow-menu
      margin-top: 80px
      .section-link

        line-height: 100%
        text-align: left
        background: transparent
        border: 0
        color: rgba(white, .7)
        border-right: 4px solid rgba(white, .2)

        h2
          font-size: 38px
          font-weight: bold
          margin: 0
        p
          font-size: 16px

        &:not(:last-child)
          margin-bottom: 20px
        &.active,
        &:hover
          border-right: 4px solid white
          font-weight: bold
          color: white
        &:active,
        &:focus
          box-shadow: none
          outline: 0

    .playnow-content
      display: none
      opacity: 0
      color: white

      transition: all .4s

      .anticheater-container
        border: 1px solid red
        border-radius: 4px

        img
          height: 80px

      &.active
        display: block
        opacity: 1
  .gamemode
    // border: 1px solid #ccc
    background: #ddd
    display: block
    padding: 10px
    height: 180px
    transform: all .4s
    h2
      margin-bottom: 0px
      transform: all .2s
    p
      color: #888
      font-size: 13px

    &:hover
      text-decoration: none
      background: linear-gradient(5deg, rgba(164,4,4,1.8673844537815126) 35%, rgba(51,5,5,0.8869922969187675) 66%)
      background-size: 200% 200%
      transform: all .2s
      color: white
      h2
        color: white
.redirecting-to-login-modal
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background: rgba(0, 0, 0, .9)
  color: white
  z-index: 9999
  display: flex
  justify-content: center
  align-items: center
  .content
    text-align: center

.ads.full-footer
  margin: 20px 0

footer.locomotiva
  padding-top: 60px
  padding-bottom: 40px
  margin-top: 160px
  background: darken(#18181A, .9)
  color: white
  .footer-logo
    text-align: center
    img
      max-width: 128px
      width: 100%
      opacity: .5
    ul
      a
        font-size: 22px
        padding: 2px
        margin: 0 2px
        &:hover
          color: white
  h5
    color: #444
  a
    color: #666
    font-size: 14px
  p
    margin-bottom: .25rem
    font-size: 11px
    color: #666
  img
    max-width: 130px
    height: auto
  small
    position: relative
    top: 4px
    left: -10px
    color: #ccc
    font-size: 10px
  .loco-logo
    display: block
    // zoom: .9;
  hr
    background-color: #333
  @media (max-width: 600px)
    .is-pulled-right
      float: none !important
      padding: 20px

.de_mirage
  background: url('/img/maps/de_mirage.jpg') no-repeat 0 !important
  background-size: cover !important
.de_cache
  background: url('/img/maps/de_cache.jpg') no-repeat 0 !important
  background-size: cover !important
.de_train
  background: url('/img/maps/de_train.jpg') no-repeat 0 !important
  background-size: cover !important
.de_inferno
  background: url('/img/maps/de_inferno.jpg') no-repeat 0 !important
  background-size: cover !important
.de_overpass
  background: url('/img/maps/de_overpass.jpg') no-repeat 0 !important
  background-size: cover !important
.de_dust2
  background: url('/img/maps/de_dust2.jpg') no-repeat 0 !important
  background-size: cover !important
.de_biome
  background: url('/img/maps/de_biome.jpg') no-repeat 0 !important
  background-size: cover !important
.de_subzero
  background: url('/img/maps/de_subzero.jpg') no-repeat 0 !important
  background-size: cover !important
.de_nuke
  background: url('/img/maps/de_nuke.jpg') no-repeat 0 !important
  background-size: cover !important
.aim_ak-colt
  background: url('/img/maps/aim_ak-colt.jpg') no-repeat 0 !important
  background-size: cover !important
.aim_map
  background: url('/img/maps/aim_map.jpg') no-repeat 0 !important
  background-size: cover !important
.fy_iceworld
  background: url('/img/maps/fy_iceworld.jpg') no-repeat 0 !important
  background-size: cover !important
.fy_pool_day
  background: url('/img/maps/fy_pool_day.jpg') no-repeat 0 !important
  background-size: cover !important
.gd_rialto
  background: url('/img/maps/gd_rialto.jpg') no-repeat 0 !important
  background-size: cover !important
.de_vertigo
  background: url('/img/maps/de_vertigo.jpg') no-repeat 0 !important
  background-size: cover !important

.ac-link
  border: 1px solid #d1d1d1
  border-radius: 4px
  background: #333
  color: white
  position: relative
  padding-top: 100px
  overflow: hidden
  display: block
  width: 256px
  margin: 0 auto

  &:hover
    background: #222
    color: white
  img
    width: 162px
    height: 162px
    position: absolute
    top: -30px
    left: 50%
    margin-left: -86px
</style>
